// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const InboxInIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "InboxIn/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1a1 1 0 1 0 0 2h1v7h-2l-1 2H8l-1-2H5V5h1a1 1 0 1 0 0-2H5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.293 7.293a1 1 0 0 1 1.414 0L9 7.586V3a1 1 0 0 1 2 0v4.586l.293-.293a1 1 0 1 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414Z"
}));
export default InboxInIcon;